module.exports = __webpack_public_path__ + "static/media/Maps_IMG-Mobile.9e9c7b25.png";